import styles from "../../common/AlertCard.scss"; 
import Toggle from "../../common/Toggle";
import OutageInfoPopup from "../../common/OutageInfoPopup";
import OutageTurnOnPopup from "./Presentational/outageTurnOnPopup";
import  HoverOAEmail from "./Common/hoverOAEmail";
import  HoverOAPhone from "./Common/hoverOAPhone";
import OutageTurnOffPopup from "./Presentational/outageTurnOffPopup";
import { getLocalizedStrings } from "../../centralizedLocalizedString";
import ReactHtmlParser from 'react-html-parser';
class OutageAlertContainer extends React.Component { 
  constructor(props) {
    super(props);
    this.state={
      prefData:"",emailOn:null,phoneOn:null,textOn:null,directMail:null,checked:null,isOpen:false,isShowPopup: false,dropDownData:"",preferenceData:"",serviceAccountData:"",isErrorCard:false,isShowViewEdit:false,hoverData:'',
      hoverModal:false,hoverPhoneModal:false,hoverType:'',categoryType:'',toggleDisabled:true,
    };
    
    
    this.imageMail_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
    this.imageMail_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOff.svg';
    this.imagePhone_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
    this.imagePhone_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOff.svg';
    this.imageText_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
    this.imageText_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOff.svg';
    this.imageInfo=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Information.svg';
    this.directMailBox_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Mailbox.svg';
    this.directMailBox_Off=null;
    let imageMailOn,imageMailOff,imageTextOn,imageTextOff,imagePhoneOn,imagePhoneOff,button,directMailBox_On,directmailBox_Off;
    this.button= <button id="outageAlertView" className={styles.ViewEditButton} onClick={this.showViewEditPopup.bind(this)}>View / Edit</button>;
    this.strings = getLocalizedStrings('RepairMaintenanceAlerts');
    this.initialPositionValue = window.getComputedStyle(document.body).position;
  }
  viewHoverPopUp =()=>{ 
    if(this.props.preferenceData.email_id.length >0){
      this.setState({ hoverModal: true , categoryType:'3'});
    }
  }
  viewHoverPhone =(category)=>{ 
    if(category===1 && this.props.preferenceData.phoneNo.length > 0){
      this.setState({ hoverData: this.props.preferenceData.phoneNo ,hoverPhoneModal: true, hoverModal: false,hoverType:'text', categoryType:'1'});
    } else if(category===2 && this.props.preferenceData.textNo.length > 0){
      this.setState({ hoverData: this.props.preferenceData.textNo ,hoverPhoneModal: true,hoverModal: false,hoverType:'voice', categoryType:'2' });
    }
  }
  componentDidUpdate() {
    // Bind the event listener
    if(this.state.categoryType==='3') {
      document.addEventListener("mousedown", this.handleEmailClose);
    }else{
      document.addEventListener("mousedown", this.handlePhoneClose);
    }
    document.addEventListener('mousedown', this.handleClickOutside);
}
  componentWillUnmount(){
    if(this.state.categoryType==='3') {
      document.removeEventListener("mousedown", this.handleEmailClose);
    }else{
      document.removeEventListener("mousedown", this.handlePhoneClose);
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
}
  handleEmailClose=()=>{ 
    this.state.hoverModal ? this.setState({ hoverModal: false }) : null;
  }
  handlePhoneClose=()=>{ 
    this.state.hoverPhoneModal ? this.setState({ hoverPhoneModal: false }) : null;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
    this.setState(
      {
        prefData:nextProps.preferenceData,
        emailOn:nextProps.preferenceData.email_id.length>0?true:false,
        phoneOn:nextProps.preferenceData.phoneNo.length>0?true:false,
        textOn:nextProps.preferenceData.textNo.length>0?true:false,
        directMailOn:nextProps.preferenceData.directMail!==null?true:false,
      },
      () => {
        this.handle();
      }
    );
  }
}
outageEnrollClick(requestObj, viewState){
  app.centralizedService.outageEnroll(this.props.accountData.bpNumber, this.props.accountData.bpCategory, requestObj, this.props.selectedAccount,this.props.mainBpNumber,this.props.accountData.contractAccountNumber).then(
    (response) =>{
      this.setState({isErrorCard:false});
      this.closePopup();
      // adding 600ms delay for refresh when its single account(Fix for ANC-877)
      let timeout = this.props.isMultiAcc === 1 ? 0 : 600;
      setTimeout(() => {
      this.props.refreshPage(this.props.accountData.contractAccountNumber, this.props.selectedAccount.contractNumber, this.props.selectedAccount.premiseNumber,false, this.props.accountData.bpNumber, this.props.accountData.bpCategory);
    }, timeout);
  }, (error) => {
    this.setState({isErrorCard: true});
  });
}
onModifyCustomerPreference(requestObj, viewState, addNewDevieDetailFlag, deleteDeviceDetailFlag) {
      let dropDownData = this.state.dropDownData;
      if(requestObj.deviceType==="email"){
          let newObj={
            "email": requestObj.modifiedValue,"standardIndicatorEmail": "","objectKey": "","record_guid": "NEW",
            "channel": "INT","sequenceNumber": "","status": "","removeFromDate": null,"addModifyFromDate": null,"addModifyToDate": null
        };
        dropDownData.emailSet.push(newObj);
      }
      else if(requestObj.deviceType==="voice"){
        let newObj={
          "telephoneNumber": requestObj.maskedValue,"encryptedPhoneNumber":requestObj.modifiedValue,"standardIndicatorVoice": "","objectKey": "",
          "record_guid": "NEW","channel": "TEL","sequenceNumber": "","indicatorSmsEnabled": "X","indicatorTelephone": "",
          "status": "","removeFromDate": null,"addModifyFromDate": null,"addModifyToDate": null
        };
        dropDownData.phoneSet.push(newObj);
        let mobileObject={...newObj, "channel": "PAG"};
        dropDownData.mobileSet.push(mobileObject);
      }else{
        let newObj={
          "telephoneNumber": requestObj.maskedValue,"encryptedPhoneNumber":requestObj.modifiedValue,"stadardIndicatorVoice": "","objectKey": "","record_guid": "NEW",
          "channel": "PAG","sequenceNumber": "","indicatorSmsEnabled": "X","indicatorTelephone": "",
          "status": "","removeFromDate": null,"addModifyFromDate": null,"addModifyToDate": null
        };
        dropDownData.mobileSet.push(newObj);
        let mobileObject={...newObj, "channel": "TEL"};
        dropDownData.phoneSet.push(mobileObject);
      }
      this.props.updateDropDownData(dropDownData);
}
getFormattedPreferenceData(){
  let preferenceData={emailSet:[],mobileSet:[],phoneSet:[],directMail:null};
  _.each(this.props.formattedDataForOutg.email_id, function(email){
      let preferenceSavedDateMilliSec = email.validFromDate ? email.validFromDate.indexOf('/')===0 ? email.validFromDate.slice(6,-2) : email.validFromDate : null;
      let preferenceSavedEDMDate = preferenceSavedDateMilliSec ? app.appUtil.DateUtil.getEDMDate(parseInt(preferenceSavedDateMilliSec)) : null;
      let data={
          email: email.email_id || "",
          standardIndicatorEmail: email.standardIndicatorEmail || '',
          objectKey: email.objectKey || '',
          record_guid: email.record_guid || 'NEW',
          channel: 'INT',
          sequenceNumber: email.sequenceNumber || '',
          status: email.status || '',
          removeFromDate: preferenceSavedEDMDate,
          addModifyFromDate: email.contactValidFrom || null,
          addModifyToDate: email.contactValidTo || null
      };
        // if(data.objectKey && data.objectKey!=='' && assignedStatusArray.indexOf(data.objectKey)===-1) assignedStatusArray.push(data.objectKey+'');
        // return data;
        preferenceData.emailSet.push(data);
  });
  _.each(this.props.formattedDataForOutg.phoneNo, function(phone){
      let preferenceSavedDateMilliSec = phone.validFromDate ? phone.validFromDate.indexOf('/')===0 ? phone.validFromDate.slice(6,-2) : phone.validFromDate : null;
      let preferenceSavedEDMDate = preferenceSavedDateMilliSec ? app.appUtil.DateUtil.getEDMDate(parseInt(preferenceSavedDateMilliSec)) : null;
      let data={
          telephoneNumber: phone.maskedPhoneNumber ? phone.maskedPhoneNumber.replace(/-/g, '') :'',
          encryptedPhoneNumber: phone.encryptedPhoneNumber || "",
          standardIndicatorVoice: phone.standardIndicatorPhoneNumber || '',
          objectKey: phone.objectKey || '',
          record_guid: phone.record_guid || 'NEW',
          channel: 'TEL',
          sequenceNumber: phone.sequenceNumber || '',
          indicatorSmsEnabled: phone.indicatorSmsEnabled  || '', 
          indicatorTelephone: phone.indicatorTelephone || '', 
          status: phone.status || '',
          removeFromDate: preferenceSavedEDMDate,
          addModifyFromDate: phone.contactValidFrom || null,
          addModifyToDate: phone.contactValidTo || null
      };
        // if(data.objectKey && data.objectKey!=='' && assignedStatusArray.indexOf(data.objectKey)===-1) assignedStatusArray.push(data.objectKey+'');
        // return data;
        preferenceData.phoneSet.push(data);
  });
  _.each(this.props.formattedDataForOutg.textNo, function(text){
      let preferenceSavedDateMilliSec = text.validFromDate ? text.validFromDate.indexOf('/')===0 ? text.validFromDate.slice(6,-2) : text.validFromDate : null;
      let preferenceSavedEDMDate = preferenceSavedDateMilliSec ? app.appUtil.DateUtil.getEDMDate(parseInt(preferenceSavedDateMilliSec)) : null;
      let data={
          telephoneNumber: text.maskedText ? text.maskedText.replace(/-/g, '') : '',
          encryptedPhoneNumber: text.encryptedText || "",
          standardIndicatorText: text.standardIndicatorPhoneNumber || '',
          objectKey: text.objectKey || '',
          record_guid: text.record_guid || 'NEW',
          channel: 'PAG',
          sequenceNumber: text.sequenceNumber || '',
          indicatorSmsEnabled: text.indicatorSmsEnabled || '', 
          indicatorTelephone: text.indicatorTelephone || '', 
          status: text.status || '',
          removeFromDate: preferenceSavedEDMDate,
          addModifyFromDate: text.contactValidFrom || null,
          addModifyToDate: text.contactValidTo || null
      };
      // if(data.objectKey && data.objectKey!=='' && assignedStatusArray.indexOf(data.objectKey)===-1) assignedStatusArray.push(data.objectKey+'');
      // return data;
      preferenceData.mobileSet.push(data);
  });
  preferenceData.directMail=this.props.formattedDataForOutg.directMail;
   return preferenceData;
}
  handle(){
    let preferenceData = this.getFormattedPreferenceData();
    let accountData = this.props.selectedAccount;
    let serviceAccountData = {
      'saAccList': [{
          'contractNumber': accountData.contractNumber,'email': '','houseNumber': accountData.houseNumber,
          'unitNumber': '','address': accountData.houseNumber + ' ' + accountData.streetAddress + ' ' + accountData.city + ' ' + accountData.state + ' ' + accountData.zipcode,
          'sreetAddress': accountData.streetAddress,'city': accountData.city,'state': accountData.state,
          'zipCode': accountData.zipcode,'premiseNumber': accountData.premiseNumber, 'serviceAddress': accountData.houseNumber + ' ' + accountData.streetAddress + ' ' + accountData.city + ' ' + accountData.state + ' ' + accountData.zipcode,
          'serviceAccountIndex': 0,'isSelected': true
        }],'serviceAccountCount': 1
    };

    let outgOpenPopup = app.appService.getSessionstorage('openPopupData') ? app.appService.getSessionstorage('openPopupData').outg : false;
    let checked = this.state.emailOn ||this.state.phoneOn || this.state.textOn ? true : false;
    outgOpenPopup ?  app.appService.removeSessionStorageItem('openPopupData') : null;
    this.setState({checked:checked, isShowPopup: this.state.isShowPopup || outgOpenPopup, isShowViewEdit: this.state.isShowViewEdit || (outgOpenPopup && checked),
      preferenceData: preferenceData,dropDownData: this.props.dropDownData,serviceAccountData: serviceAccountData,toggleDisabled:false});
    this.imageMailOn=this.state.emailOn ? <img src={this.imageMail_On} alt="Mail Image On" />:<img src={this.imageMail_Off} alt="Mail Image Off" />;
    this.imagePhoneOn=this.state.phoneOn ? <img src={this.imagePhone_On} alt="Phone Image On" /> : <img src={this.imagePhone_Off} alt="Phone Image Off" />;
    this.imageTextOn=this.state.textOn ? <img src={this.imageText_On} alt="Text Image On" /> : <img src={this.imageText_Off} alt="Text Image Off" />;
    this.directMailOn=this.state.directMailOn ? <img src={this.directMailBox_On} alt="Direct Mail Box On" />:null;
}
showViewEditPopup(){
  this.setState({ isShowViewEdit: true,isShowPopup:true}, () => { });
  window.aUtils.sendAAEvent("button","repairandmaintenanceview/edit");
  window.scrollTo(0,0);
}
handleToggleChange = (checked) => {
    this.setState({isShowPopup: true});
    window.scrollTo(0,0);
}
closePopup = () => {
  this.setState({isShowPopup: false,isShowViewEdit:false,isErrorCard: false});
}
OutageDeEnrollClick =()=>{
window.aUtils.sendAAEvent("button","repairandmaintenanceturnoff");
app.centralizedService.outageDeenroll(this.props.accountData.bpNumber, this.props.accountData.bpCategory, this.props.formattedDataForOutg,this.props.mainBpNumber).then(
    (response )=>{
   
    if(!response.errorCode){
      this.setState({checked: false, isErrorCard: false},()=>{        
        this.props.removePreference('outg', 'formattedDataForOutg');
        this.closePopup();
      });      
    }
    else{
          
      this.setState({isErrorCard:true});
    }
  },(error) => {       
  this.setState({isErrorCard:true});
  
  });
   
}
overlayFocusController() {
  if(this.state.isShowPopup) {
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  } else {
    document.body.style.position = this.initialPositionValue;
    document.body.style.removeProperty("width");
  }
}
onHoverOverEvent =(e)=>{
  if(e.type === "mouseenter"){
    this.setState({infoPopUp:true});}}
onHoverOutEvent = (e) =>{
  this.setState({infoPopUp:false});}
toolTipKeyPress= (e) =>{
  if(e.key === "Enter"){
    this.setState({infoPopUp:!this.state.infoPopUp});}}

 render() {
    this.overlayFocusController();
    let showOutageInfoPopup =  this.state.infoPopUp ? <div><OutageInfoPopup infoPopupTxt={ReactHtmlParser(this.props.staticContent.infoPopupTxt)} /> </div>: null;
    let turnOnOffPopup = !this.state.checked || this.state.isShowViewEdit ?
    <OutageTurnOnPopup strings={this.strings} closePopup={this.closePopup} 
    preferenceData={this.state.preferenceData} mainBpNumber={this.props.mainBpNumber}
    serviceAccountData={this.state.serviceAccountData} 
    outageEnrollClick={this.outageEnrollClick.bind(this)}
    onModifyCustomerPreference={this.onModifyCustomerPreference.bind(this)} 
    dropDownData={this.state.dropDownData} isErrorCard={this.state.isErrorCard}
    contractAccountNumber={this.props.accountData.contractAccountNumber} selectedAccount={this.props.selectedAccount}
    isViewEdit={this.state.isShowViewEdit} /> : <OutageTurnOffPopup handleClose={this.closePopup} accountData={this.props.accountData} selectedAccount={this.props.selectedAccount}  outageDeEnrollClick={this.OutageDeEnrollClick} isErrorCard={this.state.isErrorCard} /> ;
    let showPopup = this.state.isShowPopup ? turnOnOffPopup : null;
  return (
   <div>
       <div className={[styles.AlertCards,styles.relativePos].join(' ')}>
           <div className={styles.MainContainer}>
               <div className={styles.LeftContainer}>
                   <div className={styles.AlertCardData} onMouseLeave={this.onHoverOutEvent}>
                        <p className={styles.AlertCardTitle} id={'outageInfoPopUp'} onMouseEnter={this.onHoverOverEvent}  onClick={this.onHoverOverEvent}>
                            {this.strings.outageHeader1}<span className={styles.InfoIcon}>{this.strings.outageHeader2}<img tabIndex={0} onKeyPress={this.toolTipKeyPress} className={styles.iconAlign} src={this.imageInfo} alt="Info Icon"  /></span>
                        </p>
                        {showOutageInfoPopup}
                        {this.state.hoverModal && <HoverOAEmail  preferenceData={this.props.preferenceData.email_id}
                        handleEmailClose={this.handleEmailClose.bind(this)} />}
                        {this.state.hoverPhoneModal && <HoverOAPhone  preferenceDataPhone={this.state.hoverData} hoverText={this.state.hoverType}
                        handlePhoneClose={this.handlePhoneClose.bind(this)} />}
                        <p className={styles.AlertCardSubtitle} onMouseEnter={this.onHoverOutEvent}> {ReactHtmlParser(this.props.staticContent.subTxt)}</p>
                        <div className={styles.ButtonSection}>
                            {(this.state.checked)?<span><span onClick={this.viewHoverPopUp.bind(this)}> {this.imageMailOn}</span><span className={styles.MarginLeft16} onClick={this.viewHoverPhone.bind(this,2)}>{this.imageTextOn}</span><span className={styles.MarginLeft16} onClick={this.viewHoverPhone.bind(this,1)}>{this.imagePhoneOn}</span><span className={styles.MarginLeft16}>{this.directMailOn}</span>{this.button}</span>:null}
                        </div>
                    </div>
                </div>
                <div className={styles.DividerLine} />
                <div className={styles.RightContainer}>
                    <div className={styles.SwitchAlign}>
                        <Toggle id="repairandmaintenance" isToggleOn={this.state.checked} handleChange={this.handleToggleChange} isDisabled={this.state.toggleDisabled} />
                    </div>
                </div>
            </div>
        </div>
        {showPopup}
    </div>
    );
  }
}
export default OutageAlertContainer;
